import { parse } from 'querystring';

import { achievementsPageWithParameters } from '../../urls';

import type { DeepLinkDetails } from './types';

const parseUserAchievementsEntityId = (entityId: DeepLinkDetails['entityId']) => {
  const separator = '~';
  const { type, level, userId, path, count } = parse(entityId, separator);

  if (userId && typeof userId !== 'string') {
    throw new Error('parseUserAchievementsEntityId - Invalid userId');
  }

  if (type && typeof type !== 'string') {
    throw new Error('parseUserAchievementsEntityId - Invalid achievement type');
  }

  if (level && typeof level !== 'string') {
    throw new Error('parseUserAchievementsEntityId - Invalid achievement level');
  }

  if (path && typeof path !== 'string') {
    throw new Error('parseUserAchievementsEntityId - Invalid thread path');
  }

  if (count && typeof count !== 'string') {
    throw new Error('parseUserAchievementsEntityId - Invalid achievement count');
  }

  return {
    type,
    level,
    userId,
    path,
    count,
  };
};

export const userAchievementPageUrlFromEntityId = (entityId: DeepLinkDetails['entityId']): string => {
  const { userId, ...other } = parseUserAchievementsEntityId(entityId);
  const params = {
    type: other.type!,
    level: other.level!,
    path: other.path!,
    count: other.count!,
  };

  return achievementsPageWithParameters(userId!, params);
};
